import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { tagsApi } from "../services/tags";
import { workspaceApi } from "../services/workspaces";
import { FilterOption } from "./useTagData";

export const useWorkspaceCategories = (filterOption?: FilterOption) => {
  const { data: categories = [], isLoading: isLoadingCategories } = tagsApi.useGetTagCategoriesQuery();
  const { data: workspace } = workspaceApi.useGetWorkspaceQuery(filterOption?.workspaceId ?? skipToken);

  const workspaceCategories = useMemo(() => {
    const tempCategories = [...categories];
    if (workspace && !filterOption?.includeAll) {
      return tempCategories.filter((category) => workspace.tagCategoryIds.includes(category.tagCategoryId));
    }
    if (!filterOption) return tempCategories;
    const { include = [], exclude = [] } = filterOption;

    return tempCategories.filter((category) => {
      const isIncluded = include.length === 0 || include.includes(category.name);
      const isExcluded = exclude.includes(category.name);
      return isIncluded && !isExcluded;
    });
  }, [categories, workspace]);

  return { workspaceCategories, isLoadingCategories };
};
